import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchCompanyProfileType, updateCompanyProfileType } from "actions/companyProfileType";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/CompanyProfileType/Form";

class CompanyProfileTypeEdit extends Component {
  componentDidMount() {
    const { match, fetchCompanyProfileType } = this.props;
    const id = match.params.companyProfileTypeId;
    fetchCompanyProfileType(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.companyProfileType.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updateCompanyProfileType(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updateCompanyProfileType, history } = this.props;

    toggleFullPageSpinner(true);

    updateCompanyProfileType(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated CompanyProfileType Success", infoClassName: "is-success" });
        history.push(`/company-profile-types`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.companyProfileTypeId;

    this.updateCompanyProfileType(id, data);
  };

  render() {
    const { companyProfileType } = this.props;

    if (companyProfileType.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ companyProfileType }) => ({
  companyProfileType
});

export default connect(
  mapStateToProps,
  {
    fetchCompanyProfileType,
    updateCompanyProfileType,
    toggleFullPageSpinner,
    toggleNotification
  }
)(CompanyProfileTypeEdit);



// WEBPACK FOOTER //
// ./src/pages/CompanyProfileType/Edit/index.js